module.exports = __webpack_public_path__ + "static/media/cronicare-nav.2dde890e.png";